var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Transformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 55.77A16.004 16.004 0 1139 55h4a12 12 0 1012-12v-4a16.07 16.07 0 0116 16.77zM51 51V34l-7.07 7.1-20.5-20.53-2.83 2.83 20.5 20.53L34 51h17zM11 11h22v14.67h4V7H7v30h19v-4H11V11z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Transformation.48348770.svg";
export { SvgK1Transformation as ReactComponent };